import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components';
import classNames from 'classnames/bind';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const PopupSectionTitle = ({ title }) => (
  <div className={cx('main')}>
    <Text tag="p">
      {title}
    </Text>
  </div>
);

PopupSectionTitle.propTypes = {
  title: PropTypes.string,
};
